import React, { useState, useEffect } from 'react';
import {
     Button
  } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BillingActiveMessage from './BillingActiveMessage';
import { birthdaysloadUser } from '../../../actions/auth';
import Spinner from "../../layout-spinner/Spinner"
import { loadStripe } from '@stripe/stripe-js';
const axios = require('axios');
const axios4 = require('../../../config/axiosInstance4');
const stripePromise = loadStripe('pk_live_oYyuovMeNVaQe5SSflWCE8XD00edZonWk9');


function BillingPricesBirthdays({ auth: { birthdaysuser, birthdaysloading } }) {
    const [billing, setBilling] = React.useState("annually");
    const [stripeLoading, setstripeLoading] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);

    // Plan definitions
    const plans = [
      { id: 'starter', name: 'Starter', users: 25, monthlyPrice: 16, yearlyPrice: 12 * 12 },
      { id: 'basic', name: 'Basic', users: 50, monthlyPrice: 29, yearlyPrice: 23 * 12 },
      { id: 'growth', name: 'Growth', users: 100, monthlyPrice: 59, yearlyPrice: 48 * 12 },
      { id: 'enterprise', name: 'Enterprise', users: 200, monthlyPrice: 119, yearlyPrice: 99 * 12 },
    ];

    // TODO: Replace these placeholder price IDs with actual Stripe price IDs

    const stripePriceIds = {
      starter: {
        monthly: 'price_1Sut8FJBEzpLhH7BIHsloZAj',
        annually: 'price_1Sut9EJBEzpLhH7BGALwnxSi'
      },
      basic: {
        monthly: 'price_1SutCeJBEzpLhH7ByJp4K1kG',
        annually: 'price_1SutDCJBEzpLhH7BNcN5SQry'
      },
      growth: {
        monthly: 'price_1SutHkJBEzpLhH7BINH6AsBG',
        annually: 'price_1SutIBJBEzpLhH7BLwwMMqdd'
      },
      enterprise: {
        monthly: 'price_1SutIdJBEzpLhH7BxbGm8zI0',
        annually: 'price_1SutJAJBEzpLhH7BamVBBdm4'
      }
    };

    const handleSelectPlan = async (planId) => {
      setstripeLoading(true);
      setSelectedPlan(planId);

      const stripe = await stripePromise;
      const priceId = billing === 'monthly' 
        ? stripePriceIds[planId].monthly 
        : stripePriceIds[planId].annually;

      const plan = plans.find(p => p.id === planId);

      const configT = {
        headers: {
          'Content-Type': 'application/json',
        }
      };

      var rawBody = {
        priceId: priceId,
        slackTeamID: birthdaysuser.teamId,
        slackUserID: birthdaysuser.id,
        numUsers: plan.users,
        plan: `birthdays&${planId}${billing === 'monthly' ? 'Monthly' : 'Annually'}`
      };

      if (birthdaysuser.email !== null && birthdaysuser.email !== 'email') {
        rawBody.email = birthdaysuser.email;
      }

      const body = JSON.stringify(rawBody);

      try {
        const res = await axios4.post('/api/checkoutSessionNew/birthdayssub', body, configT);
        var sessionId = res.data;

        const { error } = await stripe.redirectToCheckout({
          sessionId: sessionId
        });

        if (error) {
          console.error(error);
          setstripeLoading(false);
          setSelectedPlan(null);
        }
      } catch (err) {
        console.error(err);
        setstripeLoading(false);
        setSelectedPlan(null);
      }
    };

    const buttonClass1 = {
      monthly: "btn btn-first",
      annually: "btn btn-second"
    };

    const buttonClass2 = {
      monthly: "btn btn-second",
      annually: "btn btn-first"
    };

    function handleMonthlyChange(evt) {
      setBilling("monthly");
    }

    function handleAnnuallyChange(evt) {
      setBilling("annually");
    }

    return (
      birthdaysloading ? <Spinner /> : birthdaysloading === false && birthdaysuser.isBillingActive === true ? <BillingActiveMessage user={birthdaysuser} /> 
        :  
      (<React.Fragment>        
        <section className="pricing py-4">
          <div className="container">
            <div className="mt-3 text-center">
              <p>Choose a plan that fits your team size. <br />
              We offer special discounts to Educational Institutions and Non-Profits. Please write to us on <b><span className="ricotta-color">cheese@ricotta.team</span></b></p>
            </div>

            {/* Billing Toggle */}
            <div className="row d-flex justify-content-center mb-4">
              <div className="btn-group" role="group" aria-label="Billing period">
                <button type="button" className={buttonClass1[billing]} onClick={handleMonthlyChange}>Monthly</button>
                <button type="button" className={buttonClass2[billing]} onClick={handleAnnuallyChange}>Annually <span className="badge badge-success ml-1">Save 20%+</span></button>
              </div>
            </div>

            <div className="row mt-4">
              {plans.map((plan) => (
                <div className="col-lg-3 col-md-6" key={plan.id}>
                  <div className="card mb-5 mb-lg-0">
                    <div className="card-body">
                      <h5 className="card-title text-uppercase text-center">{plan.name}</h5>
                      <h6 className="card-price text-center">
                        ${billing === 'monthly' ? plan.monthlyPrice : plan.yearlyPrice}
                        <span className="period">/{billing === 'monthly' ? 'month' : 'year'}</span>
                      </h6>
                      {billing === 'annually' && (
                        <p className="text-center text-muted small">(${plan.yearlyPrice / 12}/month billed annually)</p>
                      )}
                      <hr />
                      <ul className="fa-ul">
                        <li><span className="fa-li"><i className="fa fa-check"></i></span><b>Up to {plan.users} users</b></li>
                        <li><span className="fa-li"><i className="fa fa-check"></i></span>Access to all Content Packs</li>
                        <li><span className="fa-li"><i className="fa fa-check"></i></span>Automatic Birthday Celebrations</li>
                        <li><span className="fa-li"><i className="fa fa-check"></i></span>Work Anniversary Reminders</li>
                        <li><span className="fa-li"><i className="fa fa-check"></i></span>Priority Support</li>
                      </ul>
                      <Button 
                        className="btn btn-block btn-primary text-uppercase" 
                        onClick={() => handleSelectPlan(plan.id)}
                        disabled={stripeLoading}
                      >
                        {stripeLoading && selectedPlan === plan.id && (
                          <i className="fa fa-refresh fa-spin" style={{ marginRight: "5px" }} />
                        )}
                        {stripeLoading && selectedPlan === plan.id ? <span>Loading...</span> : <span>Select Plan</span>}
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-3 text-center">
              <p className="text-muted">Need more than 200 users? <a href="mailto:cheese@ricotta.team">Contact us</a> for custom pricing.</p>
            </div>
          </div>
        </section>
      </React.Fragment>)
    )
}


BillingPricesBirthdays.propTypes = {
  auth: PropTypes.object.isRequired,
  birthdaysloadUser: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, { birthdaysloadUser })(BillingPricesBirthdays);